import ChipStatus from './ChipStatus'
import ChipResult from './ChipResult'
import { Box, TableCell, Typography } from '@mui/material'
import LcCard from './LcCard'

const ItemUl = ({ ul, lcs, result, curriculum }) => {
  return (
    <>
      <TableCell>
        <div className='flex gap-2 items-center py-2'>
          <Typography className='font-bold'>{ul.ulName}</Typography>
          <ChipStatus
            status={ul?.ulStatus?.name || 'Unknown'}
            color={ul?.ulStatus?.color || 'default'}
            border={ul?.ulStatus?.border || false}
            bgColor={ul?.ulStatus?.bgColor || 'default'}
            size='small'
          />
        </div>
      </TableCell>
      <TableCell width={600}>
        <Box className='flex gap-2 items-center justify-end'>
          {lcs?.map((lc) => (
            <LcCard
              key={`ul-${ul?.ulId}-lc-${lc.lcId}`}
              lc={lc}
              color={lc?.level?.color || 'grey'}
              curriculum={curriculum}
            />
          ))}
          <ChipResult
            result={result?.name || 'Unknown'}
            color={result?.color || 'default'}
            bgColor={result?.bgColor || 'default'}
            border={result?.border || false}
          />
        </Box>
      </TableCell>
    </>
  )
}

export default ItemUl
